import { useQuery } from "@tanstack/react-query";

import { getAdminFieldListByFarmId, getFieldListByFarmId } from "services";

import { getEnvironment, getFarmIdFromLocalStorage } from "utils";

import { GET_FIELDS } from "consts";

import { FieldListField } from "models";

export const useGetFields = ({ farmId, enabled = true }: { farmId?: string; enabled?: boolean } = {}) => {
  const isAdmin = getEnvironment().admin;
  const farmIdToUse = isAdmin ? farmId : getFarmIdFromLocalStorage();

  const queryFn = isAdmin ? getAdminFieldListByFarmId : getFieldListByFarmId;

  return useQuery<FieldListField[]>({
    queryKey: [GET_FIELDS, farmIdToUse, isAdmin],
    queryFn: () => queryFn({ farmId: farmIdToUse ?? "" }),
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    enabled: enabled && !!farmIdToUse,
  });
};
